module.exports = __webpack_public_path__ + "media/country_flags/jo-33f4bc3e.png";